import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Provides the steps to install the `}<Globals name="longName" mdxType="Globals" />{` and setting up the  `}<Globals name="longName" mdxType="Globals" />{` Workshop hands on labs.`}</p>
    </PageDescription>
    <div {...{
      "className": "gatsby-resp-iframe-wrapper",
      "style": {
        "paddingBottom": "56.25%",
        "position": "relative",
        "height": "0",
        "overflow": "hidden"
      }
    }}>{` `}<iframe parentName="div" {...{
        "src": "https://www.youtube.com/embed/aFSt5cW9TlI",
        "frameBorder": "0",
        "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        "allowFullScreen": true,
        "style": {
          "position": "absolute",
          "top": "0",
          "left": "0",
          "width": "100%",
          "height": "100%"
        }
      }}></iframe>{` `}</div>
    <h2>{`1. Create OpenShift Cluster`}</h2>
    <ul>
      <li parentName="ul">{`Create an OpenShift Cluster for example:`}
        <ul parentName="li">
          <li parentName="ul">{`The 8 hours free Cluster on `}<a parentName="li" {...{
              "href": "https://developer.ibm.com/openlabs/openshift"
            }}>{`IBM Open Labs`}</a>{` select lab 6 `}<inlineCode parentName="li">{`Bring Your Own Application`}</inlineCode></li>
          <li parentName="ul">{`Deploy a Cluster on IBM Cloud VPC2 using the `}<a parentName="li" {...{
              "href": "/dev-guide/getting-started-day-0/provision-cluster/ibm-cloud-vpc"
            }}>{`Toolkit`}</a></li>
          <li parentName="ul">{`On other Clouds using docs from `}<a parentName="li" {...{
              "href": "https://cloudnativetoolkit.dev/getting-started-day-0/plan-installation/multi-cloud"
            }}>{`cloudnativetoolkit.dev/multi-cloud`}</a></li>
          <li parentName="ul">{`IBM internal DTE Infrastructure access via `}<a parentName="li" {...{
              "href": "https://ccp-ui.csplab.intranet.ibm.com/"
            }}>{`IBM VPN`}</a>{` or `}<a parentName="li" {...{
              "href": "https://ccp-ui.apps.labprod.ocp.csplab.local/"
            }}>{`IBM CSPLAB`}</a></li>
        </ul>
      </li>
    </ul>
    <h2>{`2. Install IBM Cloud Native Toolkit`}</h2>
    <ul>
      <li parentName="ul">{`Use one of the install options for example the `}<a parentName="li" {...{
          "href": "https://cloudnativetoolkit.dev/getting-started-day-0/install-toolkit/quick-install"
        }}>{`Quick Install`}</a>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -sfL get.cloudnativetoolkit.dev | sh -
`}</code></pre>
      </li>
    </ul>
    <h2>{`3. Setup IBM Cloud Native Toolkit Workshop`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Install the foundation for the workshops`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -sfL workshop.cloudnativetoolkit.dev | sh -
`}</code></pre>
        <p parentName="li">{`  `}<strong parentName="p">{`Notes`}</strong>{`: `}</p>
        <ul parentName="li">
          <li parentName="ul">{`The username and password for Git Admin is `}<inlineCode parentName="li">{`toolkit`}</inlineCode>{` `}<inlineCode parentName="li">{`toolkit`}</inlineCode>{`.  `}</li>
          <li parentName="ul">{`Usernames `}<inlineCode parentName="li">{`user01`}</inlineCode>{` through `}<inlineCode parentName="li">{`user15`}</inlineCode>{` are configured with a password of `}<inlineCode parentName="li">{`password`}</inlineCode>{`.`}</li>
          <li parentName="ul">{`Username `}<inlineCode parentName="li">{`userdemo`}</inlineCode>{` is configured with the password `}<inlineCode parentName="li">{`password`}</inlineCode>{`. You can use this username if using the workshop environment
for self study or giving a demo.  If you are preparing the environment for a workshop you can remove `}<inlineCode parentName="li">{`userdemo`}</inlineCode>{`
by running the `}<inlineCode parentName="li">{`uninstall-userdemo.sh`}</inlineCode>{` script which is part of the `}<a parentName="li" {...{
              "href": "https://github.com/cloud-native-toolkit/cloud-native-toolkit-workshop"
            }}>{`workshop`}</a>{` scripts.`}</li>
        </ul>
      </li>
    </ul>
    <h2>{`4. (Optional) Customization of the IBM Cloud Native Toolkit Workshop`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`You can customize the Workshop environment by cloning the `}<a parentName="p" {...{
            "href": "https://github.com/cloud-native-toolkit/cloud-native-toolkit-workshop"
          }}>{`workshop`}</a>{` repo`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Some of the most common customizations are:`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`You can create more than 15 users by setting a `}<inlineCode parentName="p">{`USER_COUNT`}</inlineCode>{` environment variable. For example to configure 30 users use the command`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`export USER_COUNT=30 
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`You can create more than 15 projects by setting a `}<inlineCode parentName="p">{`PROJECT_COUNT`}</inlineCode>{` environment variable. For example to configure 30 projects use the command`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`export PROJECT_COUNT=30 
`}</code></pre>
          </li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Once you have finished configuring your customizations, login to the cluster from the cli and run the `}<inlineCode parentName="p">{`scripts/install.sh`}</inlineCode>{` script to perform the install.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You can also add additional users to the workshop clusters.`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`Create a file with one user id per line.
`}<strong parentName="p">{`IMPORTANT: there needs to be newline after the last entry.`}</strong>{`
For example a `}<inlineCode parentName="p">{`users.txt`}</inlineCode>{` file with content.  `}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`additionaluserID
anotheruserID
someuserID

`}</code></pre>
            <p parentName="li"><strong parentName="p">{`Note:`}</strong>{` For Openshift clusters on IBM Cloud (ROKS) the user ids are their IBM IDs (email address) all lowercase
with an uppercase `}<inlineCode parentName="p">{`IAM#`}</inlineCode>{` prefix added to the beginning. For example.`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`IAM#additionaluserid@email.com
IAM#anotheruserid@email.com
IAM#someuserid@email.com

`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Create a `}<inlineCode parentName="p">{`ADDITIONAL_USERS_FILE`}</inlineCode>{` environment variable with the path and name of the file.`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`export ADDITIONAL_USERS_FILE=users.txt
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`The additional users will be granted the `}<inlineCode parentName="p">{`self-provisioner`}</inlineCode>{` role, meaning they can create new Openshift Projects.
If you wish to remove this permission set an environment
varable `}<inlineCode parentName="p">{`ADDITIONAL_USERS_SELF_PROVISIONER`}</inlineCode>{` with a value of `}<inlineCode parentName="p">{`N`}</inlineCode></p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`export ADDITIONAL_USERS_SELF_PROVISIONER=N
`}</code></pre>
          </li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Once you have finished configuring the additional users, login to the cluster from the cli and run the `}<inlineCode parentName="p">{`scripts/13-ocp-additional-users.sh`}</inlineCode>{` script.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      